class Cart {
  constructor() {}

  async getSection() {
    try {
      const { routes } = window.Shopify;
      const { pathname } = window.location;

      const response = await fetch(routes.root + pathname.slice(1) + '?section_id=cart-drawer', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const responseText = await response.text();

      if (!response.ok) {
        return {
          data: null,
          errors: [''],
        };
      }

      return {
        data: responseText,
        errors: [],
      };
    } catch (error) {
      console.log('Error in cart.get:', error);
    }
  }

  async get() {
    try {
      const { routes } = window.Shopify;

      const response = await fetch(routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const responseJson = await response.json();

      if (!response.ok) {
        return {
          data: null,
          errors: [responseJson.description],
        };
      }

      return {
        data: responseJson,
        errors: [],
      };
    } catch (error) {
      console.log('Error in cart.get:', error);
    }
  }

  addItem(item) {
    return this.addItems([item]);
  }

  async addItems(items) {
    try {
      const { routes } = window.Shopify;

      const response = await fetch(routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items,
          sections: 'cart-drawer',
        }),
      });

      const responseJson = await response.json();

      if (!response.ok) {
        return {
          data: null,
          errors: [responseJson.description],
        };
      }

      return {
        data: responseJson,
        errors: [],
      };
    } catch (error) {
      console.log('Error in cart.addItems:', error);
    }
  }

  removeItem(key) {
    const item = {
      // It's recommended to use the cart line item's key instead of id.
      id: key,
      quantity: 0,
    };

    return this.updateItem(item);
  }

  async updateItem(item) {
    try {
      const { routes } = window.Shopify;

      const response = await fetch(routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...item,
          sections: 'cart-drawer',
        }),
      });

      const responseJson = await response.json();

      if (!response.ok) {
        return {
          data: null,
          errors: [responseJson.description],
          status: response.status,
        };
      }

      return {
        data: responseJson,
        errors: [],
        status: response.status,
      };
    } catch (error) {
      console.log('Error in cart.updateItem:', error);
    }
  }

  async clearItems(items) {
    try {
      const { routes } = window.Shopify;

      const response = await fetch(routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const responseJson = await response.json();

      if (!response.ok) {
        return {
          data: null,
          errors: [responseJson.description],
        };
      }

      return {
        data: responseJson,
        errors: [],
      };
    } catch (error) {
      console.log('Error in cart.clearItems:', error);
    }
  }
}

export default new Cart();
